'use client'

import { createUrl } from 'lib/utils';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import {
  SortFunction
} from 'propel-react-components';
import { useCallback } from 'react';

/**
 * Hook returns a function that performs a search sort
 */
export const useSortFunction = (): SortFunction => {
  const router = useRouter();
  const pathname = usePathname() || '';
  const searchParams = useSearchParams();
  const sortFunction: SortFunction = useCallback(
    (selectedOption) => {
      // Create a function callback to update newParams
      const updateNewParams = (callback: (params: URLSearchParams) => void) => {
        const newParamsCopy = new URLSearchParams(searchParams?.toString());
        callback(newParamsCopy);

        router.push(createUrl(pathname, newParamsCopy));
      };
      if (selectedOption) {
        updateNewParams((params) => {
          for (const key of params.keys()) {
            if (key.startsWith('sort.')) {
              params.delete(key);
            }
          }

          params.set(`sort.${selectedOption.field}`, selectedOption.direction);
        });
      }
    },
    [searchParams, pathname, router],
  );

  (sortFunction as any).displayName = 'SortFunction';

  return sortFunction;
};
